import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to be an effective role model.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">isn't it interesting?</span>
                                            </div>


                                            <div className="border_subtitle">Too much to drink?</div>
                                            <p>Excessive alcohol use in US colleges has been called a
                                                ‘recalcitrant problem’. One of the ways
                                                that has been researched as a possible weapon to combat the
                                                problem is the use of role
                                                modelling. Students who were unfamiliar with heavy drinking were
                                                far more likely to be influenced
                                                by role models who drank heavily and were more likely to engage
                                                in the same behaviour than
                                                those who were already familiar. The conclusions taken were that
                                                role models who did not drink
                                                excessively could have a positive impact by making contact with
                                                new students who were not
                                                familiar with the drinking culture of a new university.</p>


                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Do violent films affect
                                                    behaviour?
                                                </div>
                                                <p>Researchers in the 1960s<a className="superscripttext"
                                                                              href="further_info.php?course=300"><sup>1</sup></a> studied
                                                    the effect of punishment on participant behaviours and
                                                    learning. They paired participants with a stooge (a fake
                                                    participant) for a ‘learning task’.
                                                    Before the start of the task the participants watched either
                                                    a violent or non-violent film with
                                                    a starring antagonist/protagnoist. Then, as part of the
                                                    learning task, the participants were
                                                    told to give the stooge an electric shock whenever they made
                                                    a mistake. The participants
                                                    were able to control and change the level of shock for each
                                                    trial. The result of the
                                                    experiment was that those who observed the violent film
                                                    would shock in higher intensities
                                                    than those who watched the non-violent movie.</p>
                                                <div className="uiheading"><p>While the claim that violent films
                                                    can increase violence in individuals in the real world is
                                                    highly contested, evidence like this shows how role models
                                                    can affect our behaviour. The
                                                    effect has been found to be particularly strong on children
                                                    where there are high levels of
                                                    ambiguity and uncertainty.</p></div>

                                            </div>

                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page2')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}